import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import { propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

const LineItemPartialRefundMaybe = props => {
  const { transaction, intl } = props;

  // Read refundItems array from protectedData
  const refundItems = transaction.attributes?.protectedData?.refundItems;

  // Only render if there are refund items
  if (!refundItems || refundItems.length === 0) {
    return null;
  }

  return (
    <div>
      <div className={css.totalDivider} />
      {refundItems.map((refund, index) => (
        <div key={index}>
          <div className={css.lineItem}>
            <span className={css.itemLabel}>
              {refund.code === 'line-item/partial-rental-refund' ? (
                <FormattedMessage id="OrderBreakdown.partialRentalRefund" />
              ) : (
                <FormattedMessage id="OrderBreakdown.depositRefund" />
              )}
            </span>
            <span className={css.itemValue}>
              {formatMoney(intl, new Money(refund.lineTotal.amount, refund.lineTotal.currency))}
            </span>
          </div>
          {refund.reasonId && (
            <p className={css.feeInfo}>
              <FormattedMessage id={refund.reasonId} />
            </p>
          )}
        </div>
      ))}
    </div>
  );
};

LineItemPartialRefundMaybe.propTypes = {
  transaction: propTypes.transaction.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemPartialRefundMaybe;
